import React, { useState } from 'react';
import { usePortletTranslations } from 'js/components/system/Portlet';
import { Icon } from 'js/components/common/Icon';
import style from './index.scss';

export default ({ children, title, tKey = 'header.title' }) => {
    const t = usePortletTranslations();
    const [expanded, setExpanded] = useState(false);

    return <>
        <div className={style.container} onClick={() => setExpanded(!expanded)}>
            <Icon type="leaderboard" className={style.icon} />
            <span className={style.title}>{title || t(tKey)}</span>
            <Icon type={expanded ? 'topArrow' : 'bottomArrow'} className={style.btn} />
        </div>
        {expanded && children}
    </>;
};
